import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15145a56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary__promo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "summary__promo--header" }, "Enter your promocode:", -1 /* HOISTED */))
const _hoisted_3 = { class: "promo__group" }
const _hoisted_4 = { class: "promo__group--tooltip" }

import { usePromo } from '@/store';
import { storeToRefs } from 'pinia';
import { PROMOS } from '@/store/cart/_constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoInput',
  setup(__props) {

const { promo, isMatch, isAlreadyApplied } = storeToRefs(usePromo());
const { applyPromo } = usePromo();

const promoKeys: string = PROMOS.map((promo) => promo.name).join('", "');

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "promocode",
        class: "promo__group--input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(promo) ? (promo).value = $event : null))
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _unref(promo)]
      ]),
      _createElementVNode("span", _hoisted_4, " Promocodes: \"" + _toDisplayString(_unref(promoKeys)) + "\"", 1 /* TEXT */),
      _createVNode(_component_AppButton, {
        class: _normalizeClass([{ disabled: !_unref(isMatch) || _unref(isAlreadyApplied) }, "promo__group--apply"]),
        onClick: _unref(applyPromo)
      }, {
        default: _withCtx(() => [
          _createTextVNode("Apply")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["class", "onClick"])
    ])
  ]))
}
}

})